import React, { createContext, useContext } from 'react';
import type { ReactNode } from 'react';

import { Permissions } from 'shared/models/permission';

import { User } from '../graphql/queries/user';

const UserContext = createContext<{ user: User; userPermissions: Permissions }>({
    user: undefined,
    userPermissions: undefined
});

interface UserContextProviderProps {
    user: User;
    userPermissions: Permissions;
    children?: ReactNode;
}

const UserContextProvider = ({ user, userPermissions, children }: UserContextProviderProps): JSX.Element => {
    return <UserContext.Provider value={{ user, userPermissions }}>{children}</UserContext.Provider>;
};

const useUserContext = () => useContext(UserContext);

export { UserContextProvider, useUserContext };
